import { ReactNode, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import useAuth from '@/hooks/useAuth'

interface GuardProps {
  children: ReactNode
}

const AuthGuard = ({ children }: GuardProps): JSX.Element | null => {
  const { isLoggedIn } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login', { replace: true })
    }
  }, [isLoggedIn, navigate])

  return <div>{children}</div>
}

export default AuthGuard
